import { create } from "zustand";
import { CommonResponseModel, intent } from "../models/axiosModel";
import agent from "../services/api";


interface intentStoreInterface {
    flagCreateIntentPopup: boolean, 
    setFlagCreateIntentPopup: (value: boolean) => void,

    intentDataList: intent[] | null,
    setIntentDataList: (value: intent[]) => void, 

    filteredIntentDataList: intent[] | null,
    setFilteredIntentDataList: (value: intent[]) => void,

    getAnalyticsIntentApiCall: () => Promise<CommonResponseModel<intent | null>>,
}

export const useIntentStore = create<intentStoreInterface>((set) => ({
    flagCreateIntentPopup: false,
    setFlagCreateIntentPopup: (value: boolean) => set({ flagCreateIntentPopup: value }),  

    intentDataList: null, 
    setIntentDataList: (value) => set({ intentDataList: value }),

    filteredIntentDataList: null, 
    setFilteredIntentDataList: (value) => set({ filteredIntentDataList: value }),

    getAnalyticsIntentApiCall: async () => {
        const response = await agent.getAnalyticsIntent.get();
        if (response.status) {
            set({ intentDataList: response.data })
            set({ filteredIntentDataList: response.data })
        }
        else {
            set({ intentDataList: null }) 
            set({ filteredIntentDataList: null })
        }
        return response;
    },
}))